import React from "react";
import { Button } from "@mui/material";

type Props = {
  handleClick: () => void;
};

export const outlinedButtonStyle = {
  color: "#BD4257",
  borderColor: "#BD4257",
  fontSize: "14px",
  fontWight: "500",
  fontFamily: "Inter",
  padding: "6px 16px",
  "&:hover": {
    borderColor: "#BD4257",
  },
};

const DeferButton = ({ handleClick }: Props) => (
  <Button
    sx={outlinedButtonStyle}
    variant="outlined"
    onClick={() => handleClick()}
  >
    Defer Replacement
  </Button>
);

export default DeferButton;
